import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	Grid,
	TextField,
	MenuItem,
} from "@mui/material";
import CustomButton from "../../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import { resetbankNameList, bankNameList } from "../../../redux/actions/bankNameListAction";
import { resetbankBranchList, bankBranchList } from "../../../redux/actions/bankBranchListAction";
import { resetbankDistrictList, bankDistrictList } from "../../../redux/actions/bankDistrictListAction";
import { resetbankMasterList, bankMasterList } from "../../../redux/actions/bankMasterListAction";
import AddNewBank from "./AddNewBank";
import NotificationPopups from "../../../NotificationPopup/NotificationPopups";
import { Card,  Modal, ModalHeader, } from "reactstrap";
import { resetbankMasterView, bankMasterView } from "../../../redux/actions/bankMasterViewAction";

function BankMasterFilter() {

    const [bankName, setbankName] = useState("");
    const [branchName, setbranchName] = useState("");
    const [bankCode, setbankCode] = useState("");
	const [openModal, setopenModal] = useState(false);
	const [action, setaction] = useState("");

	const dispatch = useDispatch();
    const login = useSelector(({ login }) => login);
	const bankbranchlist = useSelector(({ bankBranchlist }) => bankBranchlist);
	const banknamelist = useSelector(({ bankNamelist }) => bankNamelist);
	const bankMasteraddupdate = useSelector(({ bankMasterAddUpdate }) => bankMasterAddUpdate);
    const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const openAddModal = (value) => {
		setaction(value)
		setopenModal(!openModal);
	}

    const bankMasterListRequest = () => {

        const req = {
            actionCustomerMasterRequestVO : {
                bankName,
                branchName,
                bankId : login.data.partnerId,
            }
        }

        console.log(req)

		if(regenerateTokenRes.success){
			dispatch(bankMasterList(req, regenerateTokenRes.data.AuthToken))
		}		
    }

    const getBankNamesRequest = () => {

        const req = {
            actionCustomerMasterRequestVO : {
                bankId : login.data.partnerId,
            }
        }

        console.log(req)

		dispatch(bankNameList(req, regenerateTokenRes.data.AuthToken));
    }

    const getBranchNamesRequest = () => {

        const req = {
            actionCustomerMasterRequestVO: {
                bankId : login.data.partnerId,
                bankCode,
            }
        }
        console.log(req)

		dispatch(bankBranchList(req, regenerateTokenRes.data.AuthToken));
    }

	const getDistrictNamesList = () => {

        const req = {
            actionCustomerMasterRequestVO: {
                bankId : login.data.partnerId,
            }
        }
        console.log(req)

		dispatch(bankDistrictList(req, regenerateTokenRes.data.AuthToken))
    }

	const handleChange = ({ target: { value, name } }) => {
		
		if(name === "bankName"){
			setbankName(value);
			setbankCode((value.length && banknamelist.data.errorList.find((x) => x.name === value).code) || "")
		}

		if(name === "branchName"){
			setbranchName(value);
		}
	}

	useEffect(() => {
		if(bankMasteraddupdate.success){
			bankMasterListRequest();
			setopenModal(false);
			NotificationPopups(
                "success",
                "Success",
                "Details Updated"
            );
		}
		if(bankMasteraddupdate.failed){
			NotificationPopups(
                "error",
                "Failed",
                "Something Went Wrong!"
            );
		}
	}, [bankMasteraddupdate])

    useEffect(() => {
        if(regenerateTokenRes.success){
            getBankNamesRequest();
            getBranchNamesRequest();
			getDistrictNamesList()
        }
    }, [bankCode, regenerateTokenRes.success])

	useEffect(() => {
		return () => {
			dispatch(resetbankNameList());
			dispatch(resetbankBranchList());
			dispatch(resetbankDistrictList());
			dispatch(resetbankMasterList());
			dispatch(resetbankMasterView());
		}
	}, [])

  return (
	<>
    <Card>
					<Grid
						container
						style={{
							padding: "10px",
							// marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
                            textAlign: "right"
							// textAlign: "center"
						}}
					>
						<Grid item xs={12} md={8} sm={3} lg={8}></Grid>
						<Grid item xs={12} md={4} sm={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => openAddModal("addBankMaster")}
							>
								Add New Bank
							</CustomButton>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ 
                            padding: "25px", 
                            // marginTop: "2rem" 
                        }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Bank Name"
								fullWidth={true}
								name="bankName"
								defaultValue={bankName}
								onChange={handleChange}
							>
								<MenuItem value="" selected="Select Bank Name">
									Select Bank Name
								</MenuItem>
								{banknamelist.success &&
									[]
										.concat(banknamelist.data.errorList)
										.map((x) => <MenuItem value={x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Branch Name"
								fullWidth={true}
								name="branchName"
								defaultValue={branchName}
								onChange={handleChange}
							>
								<MenuItem
									value=""
									selected="Select Branch Name"
								>
									Select Branch Name
								</MenuItem>
								{bankbranchlist.success &&
									[]
										.concat(bankbranchlist.data.errorList)
										.map((x) => <MenuItem value={x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={bankMasterListRequest}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{openModal && <Modal
                isOpen={openModal}
                toggle={openAddModal}
                size="lg"            >
                <ModalHeader toggle={openAddModal}>Bank Master Details</ModalHeader>
                {/* <ModalBody className="password-modal-body"> */}
                <AddNewBank action={action}/>
                {/* </ModalBody> */}
            </Modal>}
				</>
  )
}

export default BankMasterFilter